import { Component, OnInit } from '@angular/core';
import { faChevronRight, faTimes } from '@fortawesome/pro-light-svg-icons';
import { AuthService } from '../../auth/auth.service';
import { ConfigService } from 'src/app/core/services/config.service';
import { from } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'dx-user-detail',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.scss']
})

export class UserDetailComponent implements OnInit {
  faChevronRight = faChevronRight;
  faTimes = faTimes;
  isUserActive: boolean | null = null;

  constructor(public authService: AuthService, private configService: ConfigService) { }

  get firstInitial() {
    return (this.authService.user && this.authService.user.given_name) ? this.authService.user.given_name[0] : '?';
  }

  get lastInitial() {
    return (this.authService.user && this.authService.user.family_name) ? this.authService.user.family_name[0] : '?';
  }

  ngOnInit(): void {
    const tenant = this.configService.config?.tenantDomain;
    if (this.isTicTenant()) {
      from(this.authService.isAuthenticated()).pipe(
        filter(isAuth => isAuth === true),
        take(1)
      ).subscribe(() => {
        this.configService.getUserStatus().pipe(take(1)).subscribe({
          next: (status) => {
            this.isUserActive = status as boolean;
          },
          error: () => {
            this.isUserActive = false;
          }
        });
      });
    } else {
      this.isUserActive = true;
    }
  }

  isTicTenant(): boolean {
    const tenant = this.configService.config?.tenantDomain ?? '';
    return tenant.toLowerCase().includes('ric');
  }

  logout() {
    this.authService.logout();
  }
}

